import {
  CountryUrlPrefix,
  getDefaultShortLanguageByUrlPrefix,
  getShortLanguagesByUrlPrefix,
} from '@rover/utilities/roverGeo.constants';

export type SeoLocationDescriptor = {
  countryUrlPrefix: string;
  language: string;
  citySlug: string;
  regionSlug: string;
  serviceTypeSlug: string;
  neighborhoodSlug?: string;
};

function getSeoLocationParts(
  seoLocationSegment: string
): [undefined, string, string, string] | [string, string, string, string] {
  const seoLocationParts: Array<string | undefined> = seoLocationSegment.split('--');
  if (seoLocationParts.length === 3) seoLocationParts.unshift(undefined);
  return seoLocationParts as [undefined, string, string, string] | [string, string, string, string];
}

export function parseSeoLocationFromSegments(
  countryUrlPrefixSegment: string | undefined,
  languageSegment: string | undefined,
  seoLocationSegment: string
): SeoLocationDescriptor {
  const countryUrlPrefix = (countryUrlPrefixSegment ?? 'us') as CountryUrlPrefix;
  const language =
    languageSegment && getShortLanguagesByUrlPrefix(countryUrlPrefix).includes(languageSegment)
      ? languageSegment
      : getDefaultShortLanguageByUrlPrefix(countryUrlPrefix);

  const [neighborhoodSlug, citySlug, regionSlug, serviceTypeSlug] =
    getSeoLocationParts(seoLocationSegment);

  return {
    countryUrlPrefix,
    language,
    citySlug,
    regionSlug,
    serviceTypeSlug,
    neighborhoodSlug,
  };
}

export function parseSeoLocationFromTopLevelSlug(seoLocationSlug: string): SeoLocationDescriptor {
  const pathSegments = seoLocationSlug.split('/');
  switch (pathSegments.length) {
    case 1:
      return parseSeoLocationFromSegments(undefined, undefined, pathSegments[0]);
    case 2:
      return parseSeoLocationFromSegments(pathSegments[0], undefined, pathSegments[1]);
    case 3:
      return parseSeoLocationFromSegments(pathSegments[0], pathSegments[1], pathSegments[2]);
    default:
      throw new TypeError(`Unexpected number of segments in top-level slug: ${seoLocationSlug}`);
  }
}
